<template lang="html">
  <div class="">
    <div v-if="$attrs.multiple">
      <label class="v-label">{{ internalLabel }}</label>
      <v-checkbox
        v-for="(item, index) in $attrs.items"
        ref="input"
        :key="index"
        v-model="internalValue"
        :rules="internalRules"
        :label="itemValue(item).text"
        :value="itemValue(item).value"
        persistent-hint
        :hide-details="index < $attrs.items.length - 1"
        return-object
        v-on="$listeners"
      />
    </div>
    <div v-if="!$attrs.multiple">
      <v-checkbox
        ref="input"
        v-model="internalValue"
        v-bind="$attrs"
        persistent-hint
        :label="internalLabel"
        :rules="internalRules"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: [ String, Array, Boolean ]
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.hasMulti
        ? (v || []).length > 0 || `${this.$attrs.label || 'This field'} must have at least one option selected`
        : (this.valueValid(v) && !!v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    internalValue: {
      get () {
        if (this.hasMulti && !(this.lazyValue instanceof Array)) return this.lazyValue ? [this.lazyValue] : []
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    },
    hasMulti () {
      return this.$attrs.multiple && (this.$attrs.items || []).length > 0
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  methods: {
    itemValue (item) {
      if (typeof item === 'string') {
        return { text: item || '', value: item || '' }
      } else {
        return item
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
